"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.structureType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
var _equipments = require("./equipments");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const structureType = _propTypes.default.shape({
  // [constants.ComponentTypes.Building]: PropTypes.arrayOf(buildingItemType).isRequired,
  // [constants.ComponentTypes.EdgeNode]: PropTypes.arrayOf(edgeNodeItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.HtgCc]: _propTypes.default.arrayOf(_equipments.HtgCCItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.HtgHs]: _propTypes.default.arrayOf(_equipments.HtgHsItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.HtgHx]: _propTypes.default.arrayOf(_equipments.HtgHxItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.HtgPipe]: _propTypes.default.arrayOf(_equipments.HtgPipeItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.HtgSys]: _propTypes.default.arrayOf(_equipments.HtgSysItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.PwcPoe]: _propTypes.default.arrayOf(_equipments.PwcPoeItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.PwhC]: _propTypes.default.arrayOf(_equipments.PwhCItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.PwhPipe]: _propTypes.default.arrayOf(_equipments.PwhPipeItemType).isRequired,
  [_paulCorePackage.constants.ComponentTypes.PwhSupply]: _propTypes.default.arrayOf(_equipments.PwhSupplyItemType).isRequired
});
exports.structureType = structureType;